import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

const tableName = Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_TABLE;

async function getFlraForms(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function insertFlraForm(newData) {
  try {
    return await DBOperationsComb.insertData(tableName, newData, true);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getFlraFormByID(flraId, offlineFirst = true) {
  try {
    return await DBOperationsComb.getData(tableName, flraId, offlineFirst);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getSummaryItems(flraId, offlineFirst = true) {
  const config = {
    fetchDeleted: false,
    fetchAll: true,
    queryParams: [{ field: "flra_form_id", value: flraId }]
  };

  try {
    return await DBOperationsComb.fetchData(
      {
        tableName:
          Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_SUMMARY_ITEMS_TABLE,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getSummaryItemByID(itemId) {
  const config = {
    fetchDeleted: false,
    queryParams: [{ field: "id", value: itemId }]
  };

  try {
    return await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_SUMMARY_ITEMS_TABLE,
      itemId,
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function deleteSummaryItem(itemId) {
  try {
    return await DBOperationsComb.deleteData(
      Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_SUMMARY_ITEMS_TABLE,
      [{ field: "id", value: itemId }],
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateSummaryItem(updateData) {
  try {
    return await DBOperationsComb.updateData(
      Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_SUMMARY_ITEMS_TABLE,
      updateData,
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getSignatures(flraId, offlineFirst = true) {
  const config = {
    fetchDeleted: false,
    fetchAll: true,
    queryParams: [
      { field: "record_id", value: flraId },
      {
        field: "table_name",
        value: Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_TABLE
      }
    ]
  };
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.SIGNATURES_TABLE,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function insertSignature(newData) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.SIGNATURES_TABLE,
      newData,
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function deleteSignature(signatureId) {
  try {
    return await DBOperationsComb.deleteData(
      Constants.enums.TABLES_NAME_ENUM.SIGNATURES_TABLE,
      [{ field: "id", value: signatureId }],
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateFlraForm(id, updateData, offlineFirst = true) {
  try {
    const pkg = {
      id,
      ...updateData
    };
    return await DBOperationsComb.updateData(tableName, pkg, offlineFirst);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getUniqueCreatedByList() {
  try {
    const response = await DBOperationsComb.getDistinctColumnValues(
      Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_TABLE,
      Constants.enums.FLRA_FORM_FIELD.CREATED_BY_NAME,
      false // online first
    );

    if (response.error) {
      throw new Error(response.error);
    }

    const formatted = response.data
      .filter((item) => item && Object.values(item)[0])
      .map((item) => {
        const value = Object.values(item)[0];
        return value ? { label: value, value } : null;
      });
    return {
      data: formatted,
      error: null,
      count: formatted.length
    };
  } catch (error) {
    Exception.catchException(error);
    return {
      data: [],
      error: error.message,
      count: 0
    };
  }
}

async function getDynamicForms() {
  const config = {
    fetchDeleted: false,
    fetchAll: true
  };

  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.FLRA_DYNAMIC_FORMS_TABLE,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function insertSummaryItems(newData) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.FLRA_FORM_SUMMARY_ITEMS_TABLE,
      newData,
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function createNewFlraForm(newData) {
  try {
    return await DBOperationsComb.insertData(tableName, newData, true);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getFlraForms,
  insertFlraForm,
  getFlraFormByID,
  getSummaryItems,
  getSignatures,
  updateFlraForm,
  getUniqueCreatedByList,
  getDynamicForms,
  createNewFlraForm,
  insertSummaryItems,
  insertSignature,
  deleteSignature,
  deleteSummaryItem,
  updateSummaryItem,
  getSummaryItemByID
};
